<template lang="pug">
el-collapse(v-model='indicesCollapseListaDocumentos')
    el-collapse-item(:name='`collapse-lista-documentos`')
        template(slot='title')
            span.titulo Documentos Relacionados
        .titulo.subtitle Lista de Documentos
        .collapse-item
            el-table#tabelas-collapse(:data='documentos', style='width: 100%')
                el-table-column(align='left')
                    template(slot='header', slot-scope='scope')
                        span.titulo {{ $t('mensagens.comuns.nome') }}
                    template(slot-scope='scope')
                        span {{ scope.row.nome }}

                el-table-column(align='center')
                    template(slot='header', slot-scope='scope')
                        span.titulo {{ $t('mensagens.territorio.labels.dataDeCadastro') }}
                    template(slot-scope='scope')
                        span {{ scope.row.data }}

                el-table-column(align='right')
                    template(slot='header', slot-scope='scope')
                        span.titulo.acoes {{ $t('mensagens.territorio.labels.acoes') }}
                    template(slot-scope='scope')
                        span.titulo
                            i.mdi.mdi-eye-outline(
                                @click='baixarDoc(scope.row)'
                            )
                            i.mdi.mdi-trash-can-outline(
                                v-if='!getAnyCertificado && canUploadFile',
                                @click='excluirDOc(scope.row.id)'
                            )

        el-upload.upload-btn(
            v-if='canUploadFile && !getAnyCertificado',
            action='#',
            drag,
            :file-list='fileList',
            :limit='1',
            :auto-upload='false',
            accept='.XLSX, .xlsx, .DOC, .doc, .DOCX, .docx, .pdf, .PDF, .xls, .XLS',
            :on-change='onLoadFile',
            ref='upload'
        )
            i.el-icon-upload
            .el-upload__text.w-100 Arquivos suportados: (PDF ou EXCEL) de até 10MB. <em>clique para subir</em>
</template>

<script>
import formatter from '@/utils/formatters';
import Axios from 'axios';
import UtilsService from '@/services/UtilsService';
import { mapGetters } from 'vuex';

export default {
    name: 'CollapseListaDocumentos',
    props: {
        dados: {
            type: Object,
            required: true
        },
        dadosCertificacao: {
            type: Object,
            required: true
        },
        dadosTerritorio: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            indicesCollapseListaDocumentos: [{}],
            documentos: [],
            fileList: [],
            canUploadFile: true
        };
    },
    computed: {
        ...mapGetters(['getAnyCertificado'])
    },

    mounted() {
        this.validaSeExisteCertificacao();
        this.loadDocuments();
    },

    methods: {
        formatNumber(number, decimalPlaces = 2) {
            if (!number) return '-';
            return formatter.formatNumber(number, decimalPlaces) + ' ha';
        },
        async excluirDOc(id) {
            this.$messageBox
                .confirm(
                    this.$t(
                        'mensagens.territorio.comercializacao.temCertezaqueDesejaRemoverRegistro'
                    ),
                    this.$t('mensagens.comuns.aviso'),
                    {
                        confirmButtonText: this.$t('mensagens.comuns.excluir'),
                        cancelButtonText: this.$t('mensagens.comuns.voltar'),
                        type: 'warning'
                    }
                )
                .then(() => {
                    this.handleDelete(id);
                });
        },
        async handleDelete(id) {
            let url =
                process.env.VUE_APP_HTTP_PATH +
                '/arquivoCertificacaoTerritorio/delete/' +
                id;
            const { data, status } = await Axios.delete(url);

            if (status === 200) {
                this.documentos = this.documentos.filter(doc => doc.id !== id);
                this.$notify.success({
                    message: this.$t('mensagens.certificado.sucessExcluir')
                });
            } else {
                this.$notify.error({
                    message: data
                });
            }
        },
        async baixarDoc(doc) {
            let url = 'arquivoCertificacaoTerritorio/download/' + doc.id;

            try {
                UtilsService.baixarArquivo(url);

                this.$notify.success({
                    message: this.$t('mensagens.certificado.sucessDownload')
                });
            } catch (error) {
                this.$notify.error({
                    message: this.$t('mensagens.certificado.erroDownload')
                });
            }
        },

        validFileSize(file) {
            return file.size / 1024 / 1024 < 10;
        },

        async handleUpload(file) {
            const id = this.dadosCertificacao.id;

            let url =
                process.env.VUE_APP_HTTP_PATH +
                '/arquivoCertificacaoTerritorio/upload';
            let formData = new FormData();
            formData.append('file', file.raw);
            formData.append('certificacaoTerritorioGeometriaRelId', id);

            const { data, status } = await Axios.post(url, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });

            if (status === 200) {
                this.documentos.push({
                    id: data,
                    nome: file.name,
                    data: `${new Date().getDate()}/${
                        new Date().getMonth() + 1
                    }/${new Date().getFullYear()}`
                });
                this.$refs.upload.clearFiles();

                this.$notify.success({
                    message: this.$t('mensagens.certificado.sucessoUpload')
                });
            } else {
                this.$notify.error({
                    message: this.$t('mensagens.certificado.erroUpload')
                });
            }
        },

        async onLoadFile(file) {
            this.arquivo = file;
            if (this.validFileSize(file)) {
                this.handleUpload(file);
            } else {
                this.$notify.error({
                    title: 'Erro',
                    message: 'O arquivo deve ter no máximo 10MB'
                });
                this.$refs.upload.clearFiles();
            }
        },

        validaSeExisteCertificacao() {
            const listaCertificacao =
                this.dadosCertificacao['certificacaoTerritorioResultado'];

            listaCertificacao.forEach(certificacao => {
                if (certificacao.resultadoCodigo === 'CERTIFICADO') {
                    this.canUploadFile = false;
                }
            });
        },

        loadDocuments() {
            this.dadosTerritorio.consolidadoTerritorio.arquivosCertificacaoTerritorio.forEach(
                doc => {
                    this.documentos.push({
                        id: doc.id,
                        nome: doc.nome,
                        data: `${doc.dataUpload.dayOfMonth}/${doc.dataUpload.monthValue}/${doc.dataUpload.year}`
                    });
                }
            );
        }
    }
};
</script>

<style lang="scss">
.titulo {
    font-weight: bold;
    i {
        font-size: 20px;
        cursor: pointer;
        margin-left: 5px;
    }
}
.subtitle {
    border-top: 1px solid var(--gray);
    padding-top: 5px;
}
.acoes {
    text-align: right;
}
.upload-btn {
    margin: 10px 0;
}
</style>
